import axios from "axios";
             
export const createCommentRequest = async (comment) =>
  await axios.post('https://coronadosdelbien.com/comment' , comment);